<template>
  <div class="emd-panel__section">
    <div class="emd-panel__block">
      <div class="el-chunk">
        <h2 class="emd-text _color_default _type_caption">
          {{ $t(acquirer.payment_method) }}
        </h2>
      </div>
    </div>
    <div class="emd-panel__block">
      <JadeBox>
        <div
          class="eu-display_flex eu-row eu-align-items_center eu-justify_space-between"
        >
          <jade-list-item
            class="h-20"
            :label="
              $t('description.create', {
                acquirer: this.$t(this.acquirer.payment_method)
              })
            "
          >
            <template #leading>
              <component :is="acquirerImageComponent" />
            </template>

            <template #trailing>
              <jade-button
                v-if="canCreate"
                size="medium"
                variant="primary-solid"
                :loading="loading"
                @click="() => $emit('handleCreate', acquirer)"
              >
                {{ $t('register') }}
              </jade-button>
            </template>
          </jade-list-item>
        </div>
      </JadeBox>
    </div>
  </div>
</template>

<script>
import { JadeBox, JadeText, JadeButton, JadeListItem } from '@jade'
import { ICON_COMPONENT_MAP } from '../affiliations-payment-methods.enum'

export default {
  name: 'CreateAffiliationItem',

  components: {
    JadeBox,
    JadeText,
    JadeButton,
    JadeListItem
  },

  props: {
    acquirer: {
      type: Object,
      required: true
    },
    loading: Boolean,
    canCreate: Boolean
  },

  computed: {
    acquirerImageComponent () {
      return ICON_COMPONENT_MAP[this.acquirer.payment_method]
    }
  }
}
</script>

<i18n src="../affiliations.translation.json" />

<i18n>
  {
    "pt-BR": {
      "register": "Cadastrar",
      "description.create": "Conecte-se com a {acquirer} de forma segura e eficiente através do novo processo de autenticação Connect Auth."
    },
    "en-US": {
      "register": "Register",
      "description.create": "Connect securely and efficiently with {acquirer} through the new Connect Auth authentication process."
    }
  }
</i18n>
